import AuthHOC from "../hoc/AuthHOC";
import AA_GLOBAL from "../globals/globals";

const PublicAndPrivate = page => {
  const authToken = AA_GLOBAL.cookies.get("auth_token");

  return authToken ? AuthHOC(page) : page;
};

export default PublicAndPrivate;
